import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './components/App';
import '@styles/global.sass';
import { store } from './store/store';
import ExternalComponent from "@components/externalComponent";
console.info(`Artsyl Assistant ${__APP_VERSION__}`);
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container with id "root" was not found in the DOM.');
}
const root = createRoot(container);
let component;
if (document.location.pathname === '/external') {
    component = _jsx(ExternalComponent, {});
}
else {
    component = (_jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(App, {}) }) }));
}
root.render(component);
